exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment_option_ors.success{border-color:#38c172!important}.black-border-bottom{border-bottom:1px solid #666}.color-black{color:#000}.new-price,.text-600{font-weight:600}.new-price{color:#0872ba;font-size:18px}.success-message{color:#38c172;font-size:16px}", ""]);

// exports
